import { Card, Col, Divider, Row } from "antd";
import React from "react";
import dayjs from "dayjs";
import Text from "../../../components/Text/Text";
import { ShopDetail, SlotProductDetail } from "../DetailFlashSale";

export const FlashSaleStepFive: React.FC<{ form: any }> = ({ form }) => {
  const dataForm = form.getFieldsValue(true);
  const diffHours = dayjs(dataForm?.mainStartDate).diff(dayjs(dataForm?.previewDate), "hour");
  const days = Math.floor(diffHours / 24);
  const hours = diffHours % 24;

  const into = [
    { label: "ชื่อรายการ", value: dataForm?.flashSaleName },
    { label: "แบรนด์สินค้าที่ต้องการขาย", value: dataForm?.productBrandName },
    {
      label: "ระยะเวลาโปรโมชัน",
      value: `${dayjs(dataForm?.mainStartDate).format("DD/MM/YYYY")} (${dayjs(dataForm?.mainStartDate).format("HH:mm")}) - ${dayjs(dataForm?.mainEndDate).format("DD/MM/YYYY")} (${dayjs(dataForm?.mainEndDate).format("HH:mm")}) (${dataForm?.rounds?.length} รอบ)`,
    },
    {
      label: "เปิดให้ร้านเห็นแคมเปญล่วงหน้า",
      value:
        `${dayjs(dataForm?.previewDate).format("DD/MM/YYYY")}, ${dayjs(dataForm?.previewTime).format("HH:mm")} ` +
        "(" +
        (days > 0 ? days + " วัน " : "") +
        (hours > 0 ? hours + " ชั่วโมง" : "") +
        ")",
    },
    {
      label: "ระยะเวลาล็อคตะกร้า",
      value: `${dataForm?.cartLockTime} นาที`,
    },
    {
      label: "จัดส่งฟรี",
      value: dataForm?.isFreeShip ? "ทุกคำสั่งซื้อได้รับสิทธิ์จัดส่งฟรี" : "-",
    },
  ];

  return (
    <>
      <div>
        <span
          className='card-label font-weight-bolder text-dark'
          style={{ fontSize: 20, fontWeight: "bold" }}
        >
          ตรวจสอบข้อมูล
        </span>
      </div>
      <br />
      <Row justify='space-between' gutter={[16, 16]}>
        {into.map((item, index) => (
          <Col key={index} span={12}>
            <Card
              bodyStyle={{
                padding: 10,
                backgroundColor: "#F3F6F9",
                borderRadius: 8,
                border: "none",
              }}
            >
              <Text color='Text3' fontFamily='Sarabun'>
                {item.label}
              </Text>
              <br />
              <Text fontFamily='Sarabun'>{item.value}</Text>
            </Card>
          </Col>
        ))}
      </Row>
      <Divider />
      <div style={{ paddingBottom: "16px" }}>
        <Text level={4} fontWeight={600}>
          ร้านค้าที่เข้าร่วม {dataForm?.shops?.length || 0} ร้าน
        </Text>
      </div>
      <ShopDetail flashSaleId={dataForm?.flashSaleId} isCredit={true} company={dataForm?.company} />
      <Divider />
      <div style={{ paddingBottom: "16px" }}>
        <Text level={4} fontWeight={600}>
          รอบวันเวลา และสินค้า
        </Text>
      </div>
      <SlotProductDetail
        rounds={dataForm?.rounds}
        isSearch={false}
        company={dataForm?.company}
        dataForm={dataForm}
      />
    </>
  );
};
